import axios from "axios"

import { apiDomain } from "../../store/constants"

const AForm = {
    getMasterFormA (id) {
        return axios({
            url: apiDomain + `api/form-a/create?main_project_id=` + id,
            method: 'GET'
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    storeFormA (data) {
        return axios({
            url: apiDomain + `api/form-a`,
            method: 'POST',
            data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    updateFormA (data) {
        return axios({
            url: apiDomain + `api/form-a/` + data.id,
            method: 'PUT',
            data: data.payload
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    approvedFormA (id) {
        return axios({
            url: apiDomain + `api/form-a/approved/` + id,
            method: 'PUT'
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    RewindStatus (id) {
        console.log("AFORM service", id)
        return axios({
            url: apiDomain + `api/form-a/rewind-status/` + id,
            method: 'PUT'
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    getFormAList (params) {
        return axios({
            url: apiDomain + `api/form-a`,
            method: 'GET',
            params
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    getEditMasterFormA (id) {
        return axios({
            url: apiDomain + `api/form-a/` + id + '/edit',
            method: 'GET',
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
    storeNewProgressFormA (data) {
        return axios({
            url: apiDomain + `api/form-a/new-progress/` + data.id,
            method: 'POST',
            data: { ...data, id: undefined }
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
    deleteFormAList (id) {
        return axios({
            url: apiDomain + `api/form-a/${id}`,
            method: 'delete',   
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
}

export default AForm